import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ChemicalPeelsHero } from '../components/chemical-peels/ChemicalPeelsHero';
export function ChemicalPeelsPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2449">
      <Navigation data-id="element-2450" />
      <main data-id="element-2451">
        <ChemicalPeelsHero data-id="element-2452" />
      </main>
      <Footer data-id="element-2453" />
    </div>;
}